import classNames from "classnames";
import classes from "./GalleryShimmer.module.css";

const GalleryItemShimmer = (props) => {
  return (
    <div className={classes.root}>
      <div className={`${classes.rootContent} placeholder-glow`}>
        <div className={classes.Image}>
          <span
            className={classNames("placeholder", classes.backgroundTransparent)}
          />
        </div>
        <div className={classes.Details}>
          <div
            className={classNames(
              classes.Title,
              "placeholder",
              classes.backgroundTransparent
            )}
          />
          <div className={classes.PriceContent}>
            <span
              className={classNames(
                classes.OfferPrice,
                "placeholder",
                classes.backgroundTransparent
              )}
            />
            <span
              className={classNames(
                classes.OfferPrice,
                "placeholder",
                classes.backgroundTransparent
              )}
            />
            <span
              className={classNames(
                classes.unitSet,
                "placeholder",
                classes.backgroundTransparent
              )}
            />
            <span
              className={classNames(
                classes.price,
                "placeholder",
                classes.backgroundTransparent
              )}
            />
          </div>
        </div>
        <div className={classes.Actions}>
          <div className={classes.AddtoCartBtn}>
            <button
              className={`btn btn-secondary placeholder ${classes.backgroundTransparent}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GalleryItemShimmer;
